<script setup lang="ts">
import type { InvestigationCollectionItem } from '@nuxt/content'

const props = defineProps<{
  article: InvestigationCollectionItem
}>()
</script>

<template>
  <header class="flex items-center border-b border-neutral-200 dark:border-neutral-800 h-40">
    <image-cover :src="props.article.image.src" :alt="props.article.image.alt" class="flex items-end p-4 justify-items-start">
      <h2 class="font-heading font-bold text-primary-50 dark:text-white text-shadow-xl  text-xl text-pretty">
        {{ props.article.title }}
      </h2>
    </image-cover>
  </header>
</template>
